<form [formGroup]="addDataForm">
    <acabim-form-block labelWidth="8" [labelAlign]="'right'" [colonize]="true">
        <acabim-form-input-wrapper>
            <acabim-form-input-label>{{detailType | titlecase}}</acabim-form-input-label>
            <acabim-form-input-content [longField]="true">
                <input type="text" formControlName="detail" />
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Type</acabim-form-input-label>
            <acabim-form-input-content [longField]="true">
                <p-dropdown [options]="addDataOptions" optionLabel="label" formControlName="type"></p-dropdown>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label>Default</acabim-form-input-label>
            <acabim-form-input-content>
                <p-checkbox binary="true" formControlName="isDefault" id="cy-isDefault"></p-checkbox>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
        <acabim-form-input-wrapper>
            <acabim-form-input-label [withLabel]="false"></acabim-form-input-label>
            <acabim-form-input-content>
                <div class="cas-action-buttons cas-action-buttons-bottom">
                    <button
                        type="button"
                        (click)="onAdd()"
                        data-cy="_t-add-detail-input"
                        class="cas-button-action cas-action-buttons-centred">{{label}}</button>
                </div>
            </acabim-form-input-content>
        </acabim-form-input-wrapper>
    </acabim-form-block>
</form>
